import SEO from '../components/SEO';
import DeveloperToolsPanel from '../components/DeveloperToolsPanel';

export default function ENVConverterPage() {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "ENV to YAML Converter - JsonToonCraft",
    "applicationCategory": "DeveloperApplication",
    "operatingSystem": "Web",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "description": "Free ENV to YAML converter. Convert .env files and environment variables to YAML format.",
    "featureList": [
      "ENV to YAML conversion",
      ".env file conversion",
      "Preserves comments",
      "Handles quoted values",
      "Instant conversion",
      "Copy to clipboard"
    ]
  };

  return (
    <>
      <SEO
        title="ENV to YAML Converter - Convert Environment Variables to YAML | JsonToonCraft"
        description="Free ENV to YAML converter. Convert .env files and environment variables to YAML format. Preserves comments and handles quoted values."
        keywords="ENV to YAML, environment variables converter, .env converter, dotenv to YAML, config converter"
        canonicalUrl="https://jsontooncraft.com/dev-tools/env-converter"
        structuredData={structuredData}
      />

      <DeveloperToolsPanel initialTool="env" />
    </>
  );
}
